import { canv } from "@/canv/global.js";
import { getTarget } from "@/canv/utils.js";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmTextBackground extends wmBase {
    constructor(options: widgetOption[]) {
        super();
        this.options = options;
    }

    build() {
        return `
            <div class="wm_textBackground">
                <svg width="23" height="23" viewBox="0 0 76 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M75.5 0.5L75.5 52C75.5 55.5899 72.5899 58.5 69 58.5L7 58.5C3.41015 58.5 0.5 55.5899 0.5 52L0.5 0.5L75.5 0.5Z" fill="black"/>
                <path d="M75.5 0.5L75.5 52C75.5 55.5899 72.5899 58.5 69 58.5L7 58.5C3.41015 58.5 0.5 55.5899 0.5 52L0.5 0.5L75.5 0.5Z" fill="url(#paint0_linear_1392_228)" fill-opacity="0.2"/>
                <path d="M75.5 0.5L75.5 52C75.5 55.5899 72.5899 58.5 69 58.5L7 58.5C3.41015 58.5 0.5 55.5899 0.5 52L0.5 0.5L75.5 0.5Z" stroke="black"/>
                <path d="M66.5 59.5V74C66.5 76.4853 64.4853 78.5 62 78.5L13 78.5C10.5147 78.5 8.5 76.4853 8.5 74V59.5L66.5 59.5Z" fill="#474747"/>
                <path d="M66.5 59.5V74C66.5 76.4853 64.4853 78.5 62 78.5L13 78.5C10.5147 78.5 8.5 76.4853 8.5 74V59.5L66.5 59.5Z" fill="url(#paint1_linear_1392_228)" fill-opacity="0.2"/>
                <path d="M66.5 59.5V74C66.5 76.4853 64.4853 78.5 62 78.5L13 78.5C10.5147 78.5 8.5 76.4853 8.5 74V59.5L66.5 59.5Z" stroke="black"/>
                <path d="M56.5 79.5V95.9795C56.5 97.6511 55.5734 99.185 54.0938 99.9628L25.0938 115.206C22.0973 116.781 18.5 114.608 18.5 111.223L18.5 79.5H56.5Z" fill="black" stroke="black"/>
                <defs>
                <linearGradient id="paint0_linear_1392_228" x1="76" y1="29.5" x2="0" y2="29.5" gradientUnits="userSpaceOnUse">
                <stop/>
                <stop offset="0.213542" stop-color="white" stop-opacity="0.08"/>
                <stop offset="0.71875" stop-color="white" stop-opacity="0.08"/>
                <stop offset="1"/>
                </linearGradient>
                <linearGradient id="paint1_linear_1392_228" x1="67" y1="69" x2="8" y2="69" gradientUnits="userSpaceOnUse">
                <stop/>
                <stop offset="0.333333" stop-color="white" stop-opacity="0.08"/>
                <stop offset="0.666667" stop-color="white" stop-opacity="0.08"/>
                <stop offset="1"/>
                </linearGradient>
                </defs>
                </svg>
            </div>
            <div class="wm_dividor"></div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_textBackground");
        item?.removeEventListener("click", this.toggleSubMenu, false);
        item?.addEventListener("click", this.toggleSubMenu, false);
    }

    toggleSubMenu = (e) => {
        const subm = document.querySelector(".wm_textBackground_submenu");
        if (subm) {
            subm.outerHTML = "";
            return;
        }
        const otherSubm = document.querySelector(".widgetSubMenu");
        if (otherSubm) {
            otherSubm.outerHTML = "";
        }

        canv.widgetMenu.subMenuBoss = "wm_textBackground";
        const submenu = document.createElement("div");
        submenu.classList.add("widgetSubMenu");
        submenu.classList.add("wm_textBackground_submenu");
        submenu.style.opacity = "0";
        document.body.prepend(submenu);

        for (let i = 0; i < this.colors.length; i++) {
            submenu.innerHTML += this.submenuColorTemplate(this.colors[i], i);
        }

        const pallet = document.querySelector<HTMLElement>(
            ".wm_textBackground_submenu_item_pallete",
        );
        pallet?.removeEventListener("input", this.colorPickerPick.bind(this));
        pallet?.addEventListener("input", this.colorPickerPick.bind(this));
        pallet?.removeEventListener("open", this.colorPickOpen.bind(this));
        pallet?.addEventListener("open", this.colorPickOpen.bind(this));
        pallet?.removeEventListener("close", this.colorPickClose.bind(this));
        pallet?.addEventListener("close", this.colorPickClose.bind(this));

        const items = document.querySelectorAll<HTMLElement>(".wm_textBackground_submenu_item");
        for (let i = 0; i < items.length; i++) {
            items[i].removeEventListener("click", this.itemClick.bind(this), false);
            items[i].addEventListener("click", this.itemClick.bind(this), false);
        }

        setTimeout(canv.widgetMenu.TryLocateMenu.bind(canv.widgetMenu), 50);
    };

    colorPickerPick(e: Event) {
        const ttt = document.querySelector(".wm_textBackground_submenu_item_pallete");
        if (!ttt) {
            return;
        }
    }

    colorPickOpen(e: Event) {
        canv.widgetMenu.colorPickOpen = true;
        canv.appInterface.inputFocused = 1;
    }

    colorPickClose(e: Event) {
        canv.widgetMenu.colorPickOpen = false;
        canv.appInterface.inputFocused = 0;
    }

    itemClick = (e: Event) => {
        const item = getTarget(e, "wm_textBackground_submenu_item");
        const numAttr = item.getAttribute("num");
        if (!numAttr) return;
        const num = Number.parseInt(numAttr, 10);
        if (Number.isNaN(num)) return;

        let value = this.colors[num];
        let menuValue = this.colors[num];
        if (num === 17) {
            return;
        }

        if (num === 0) {
            value = "none";
            menuValue = "white";
        }

        this.applyValue(this.options, value);
    };

    submenuColorTemplate(color: string, num: number) {
        let ifInp = "";
        if (num === 17) {
            ifInp = `<input type="text" class="wm_textBackground_submenu_item_pallete" data-coloris>`;
        }

        if (num === 0) {
            return `
                    <div class="wm_textBackground_submenu_item" num=${num}>
                        <div class="wm_textBackground_submenu_item_no">
                            <div></div>
                        </div>
                    </div>
            `;
        }

        return `
            <div class="wm_textBackground_submenu_item" num=${num}>
                ${ifInp}
                <div style="background: ${color}"></div>
            </div>
        `;
    }

    name = "wm_textBackground";
    options: widgetOption[] = [];
    colors = [
        "rgb(255, 255, 255)",
        "rgb(17, 17, 17)",
        "rgb(224, 62, 26)",
        "rgb(247, 151, 34)",
        "rgb(243, 193, 27)",
        "rgb(25, 143, 81)",
        "rgb(12, 140, 233)",
        "rgb(138, 56, 245)",
        "rgb(255, 255, 255)",
        "rgb(56, 56, 56)",
        "rgb(217, 217, 217)",
        "rgb(251, 188, 182)",
        "rgb(255, 196, 112)",
        "rgb(249, 223, 144)",
        "rgb(161, 232, 185)",
        "rgb(168, 215, 250)",
        "rgb(214, 182, 251)",
        `radial-gradient(50% 50% at 50% 50%,#ffffff 0%,transparent 100%),conic-gradient(from
            0deg at 50% 50%,#ff0000
            0deg,#ffa800
            47.73deg,#ffff00
            79.56deg,#00ff00
            121.33deg,#00ffff
            180.99deg,#0000ff
            238.67deg,#ff00ff
            294.36deg,#ff0000
            360deg),#c4c4c4;`,
    ];
}
